(function () {
  function reorderByDiscount(section) {
    if (section.dataset.sortDiscount !== 'true') return;
    var list = section.querySelector('.slider-list');
    if (!list) return;
    var items = Array.prototype.slice.call(list.querySelectorAll(':scope > .slider-item'));
    if (items.length < 2) return;
    items
      .sort(function (a, b) {
        return (parseFloat(b.dataset.discount) || 0) - (parseFloat(a.dataset.discount) || 0);
      })
      .forEach(function (item) {
        list.appendChild(item);
      });
  }

  function resyncCarousel(section) {
    document.dispatchEvent(new CustomEvent('product-card-carousel:resync', { detail: { section: section } }));
  }

  function initSection(section) {
    if (section.dataset.dealsInit === 'true') return;
    var slider = section.querySelector('slider-component');
    if (!slider || typeof slider.init !== 'function') return;

    reorderByDiscount(section);
    var instance = slider.init();
    section.dataset.dealsInit = 'true';

    resyncCarousel(section);

    if (instance && instance.events && typeof instance.events.on === 'function') {
      instance.events.on('transitionEnd', function () {
        resyncCarousel(section);
      });
      instance.events.on('indexChanged', function () {
        resyncCarousel(section);
      });
    }
  }

  function run() {
    if (!window.customElements || !customElements.get('slider-component')) return;
    if (document.readyState === 'loading') return;
    document.querySelectorAll('.ubiquiti-hot-deals').forEach(initSection);
  }

  document.addEventListener('global.js loaded', run);
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  run();
})();
